
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import MaintenancePage from './components/MaintenancePage';

// Modo manutenção: definir VITE_MAINTENANCE_MODE=true nas variáveis de ambiente
// da Vercel (Production) e fazer Redeploy. Com true, só a página de manutenção
// é renderizada (sem App, AuthProvider ou chamadas ao backend).
const isMaintenance = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {isMaintenance ? (
      <MaintenancePage />
    ) : (
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    )}
  </React.StrictMode>
);
